import { getschool } from '@/port/admins/organizationSpace'
import { emitter } from '@/util/util'
import { calculateDaysDiff } from '@/api/common'
import { defineAsyncComponent } from 'vue'
import { adddefaultdesk, addspacedefaultdesk } from '@/port/common/schoolNews'
import spaceMixin from '@/components/schoolInstrument/mixins/spaceMixins.js'
import { cloneDeep } from 'lodash'
import { Search } from '@element-plus/icons-vue'
import { axiosBase } from "@/api/api"

export default {
    mixins: [spaceMixin],
    data() {
        return {
            bodyWidth: document.body.clientWidth,
            dialogInfo: {
                isVisible: false,
                dialogName: '',
                dialogHeight: '',
                dialogWidth: '',
                dialogUrl: '',
                openType: 'dialog',
                customSize: 65
            },
            openInput: {
                isVisible: false,
                approvalId: '',
                search: {},
                iId: ''
            },
            openAddInputShow: false, // 发起单独使用的
            isPopValue: false,
            customId: '-1',
            //- 搜索
            searchInput: "",
            //- 用户数据
            sysUserMsg: "",
            //- 学校信息
            userMsg: {},
            schoolList: [],
            //- 学校id
            schoolId: "",
            spaceid: this.$route.query.spaceid,
            upaceid: this.$route.query.upaceid,
            curType: '',
            navbarIsScroll: false,
            transformX: 0,
            transformIdx: 0,
            isMax: false,
            isMin: true,
            memberInfo: {
                level: '',
                expireDate: ''
            },
            openVip: false, //是否开启会员
            isVip: false, //是否已开通会员
            vipPayShow: false, //会员支付弹窗
        }
    },
    components: {
        schoolNews: defineAsyncComponent(() => import("../schoolNews")),
        AppDialog: defineAsyncComponent(() => import('@/components/schoolInstrument/mixins/AppDialog.vue')),
        topBtn: defineAsyncComponent(()=> import('./topBtn.vue')),
        upOption: defineAsyncComponent(() => import('@/components/schoolInstrument/mixins/upOption.vue')),
        vipPay: defineAsyncComponent(() => import('@/components/common/vipPay/index')),
        Search,
    },
    computed: {
        getLoginText() {
            const openLogin = Boolean(this.registerconfig.openLogin)
            const openregister = Boolean(this.registerconfig.openregister)
            if (!this.openWebsite) return true
            if (openLogin) {
                return '登录'
            } else if (openregister) {
                return '注册'
            } else if (!openLogin && !openLogin) {
                return false
            }
        },
        navFree() {
            return this.styleInfo.topAdsorption === 'free'
        },
        styleObject() {
            return {
                "--background-color": this.themeColor,
            };
        },
        hadnleSwitch() {
            let res
            if (this.styleInfo.uploadImg === 'open') {
                if (this.styleInfo.iconImgUrl) {
                    res = this.$imgurl + this.styleInfo.iconImgUrl
                } else {
                    res = 'https://bigdata.topeti.com/PCRepository/middleground/default-logo.png'
                }
            } else {
                if (this.styleInfo.iconColor === 'deepColor') {
                    res = 'https://bigdata.topeti.com/PCRepository/middleground/home/icon/header/switch-deepColor.svg'
                } else {
                    res = 'https://bigdata.topeti.com/PCRepository/middleground/home/icon/header/switch-lightColor.svg'
                }
            }
            return res
        },
        navThemeObject() {
            let themeColor = '#4e86ff'
            const { navColor, navStyle, navCustomColor } = this.styleInfo
            if (navColor === 'theme') {
                themeColor = this.themeColor
            } else if (navColor === 'custom') {
                themeColor = navCustomColor
            } else {
                if (navStyle === 'colorBlock' || navStyle === undefined) {
                    themeColor = '#3333333d'
                } else {
                    themeColor = 'white'
                }
            }
            return {
                "--navtheme-color": themeColor,
            }
        },
        activeTextObject() {
            let themeColor = '#4e86ff'
            const { checkColor, checkCustomColor } = this.styleInfo
            if (checkColor === 'theme') {
                themeColor = this.themeColor
            } else if (checkColor === 'custom') {
                themeColor = checkCustomColor
            } else {
                themeColor = '#fff'
            }
            return {
                "--activeText-color": themeColor,
            }
        },
        isNews() {
            return this.$route.query.isNews
        },
        spaceAppenComp() {
            const flag = !this.spaceid && this.spaceAppen
            return flag
        },
    },
    watch: {
        contentInfo(newVal) {
            Object.assign(this.topData, newVal);
            
            this.changeScrollItem()
            this.setBg();
        },
        customId(val) {
            this.$emit('update:chooseRoleId', val)
        },
        chooseRoleId: {
            handler(val) {
                this.customId = val
            },
            immediate: true
        }
    },
    props: {
        isAppenLi: {
            type: Boolean,
            default: false
        },
        isCollapse: {
            type: Boolean,
            default: false
        },
        adminload: {
            type: Number,
            default: 0
        },
        rolesList: {
            type: Array,
            default: () => {
                return []
            }
        },
        chooseRoleId: {
            type: [Number, String],
        },
        openRole: {
            type: Boolean,
            default: true,
        },
        // 官网开关
        openWebsite: {
            type: Boolean,
            default: false,
        },
        styleInfo: {
            type: Object,
            default: function () {
                return null;
            },
        },
        checkObj: {
            type: Object,
            default: function () {
                return null;
            },
        },
        contentInfo: {
            type: Object,
            default: function () {
                return null;
            },
        },
        themeColor: {
            type: String,
            default: '#4e86ff'
        },
        //- 当前导航栏展示模式：1：前台，2：后台
        typeShow: {
            type: Number,
            default: 1,
        },
        activeTopChildMenu: {
            type: Number,
            default: 0
        },
        activeTopMenu: {
            type: Number,
            default: 1
        },
        isCustomDesk: {
            type: Boolean,
            default: false
        },
        spaceAppen: {
            type: Boolean,
            default: false
        },
        cloudAppen: {
            type: Boolean,
            default: false
        },
        upaceAppen: {
            type: Boolean,
            default: false
        },
        registerconfig: {
            type: Object,
            default: () => ({})
        },
        customDeskInfo: {
            type: Object,
            default: () => ({})
        },
    },
    mounted() {
        //- 获取学校缓存消息
        this.getMessage()
        Object.assign(this.topData, this.contentInfo);
        this.setBg();
        emitter.on('change-avatar', (e) => {
            this.userMsg.avatar = e
        })
        this.$nextTick(() => {
            this.bodyWidth = document.body.clientWidth
        })
        // 未测试，先注释
        // this.getUserVip()
    },
    update() {
        this.changeScrollItem()
    },
    methods: {
        openAppDialog(val){
            this.dialogInfo = val
        },
        doorUpCloe() {
            this.openInput = {
                isVisible: false,
                approvalId: '',
                search: {},
                iId: ''
            }
        },
        openDictionary(info) {
            // 打开字典
            console.log(info,'infoinfoinfo')
            const val = cloneDeep(info)
            if (val.schoolId) delete val.schoolId;
            let str = typeof val.options === 'string' ? JSON.parse(val.options) : val.options
            str = str.join(',')
            val.options = str.replace(/,/g, '\n')
            this.$refs.upOption.viewDialog({ title: '编辑选项' }, val);
        },
        toBtnNav(val = {}) {
            const { type, page } = val
            if (type === 'top') {
                this.active(0, page)
            } else {
                this.$emit('changeNav', val)
            }
        },
        customScene(val) {
            const { open, popUps, url } = val
            popUps.width = popUps.w
            popUps.height = popUps.h
            const openType = {
                3: 'new',
                2: 'dialog',
                4: 'olg'
            }
            const opt = {
                chooseOpen: openType[open],
                dialogInfo: popUps,
                customSize: popUps.customSize,
                navType: 'nav',
                type: 'customDesk'
            }
            const itme = {
                pcUrl: url,
                params: ''
            }
            this.goCustomDesk(itme, opt)
        },
        openAppInitiate({ approvalId, name, search, iId, id, datatype }) {
            this.openInput = {
                isVisible: true,
                approvalId: approvalId,
                name: name,
                search: search,
                iId: iId,
                isDetail: iId === 15 || iId === 16 /*|| iId === 13 || iId === 14*/,
                id: id || '',
                datatype: datatype
            }
            this.openAddInputShow = true
        },
        // 滚动，上一项
        changeTab (type) {
            const list = [...this.$refs.column]
            const navbar = this.$refs.navbar
            const scrollWidth = navbar.scrollWidth
            const navbarMask = this.$refs['navbar-mask']
            const totalWidth = navbarMask.getBoundingClientRect().width
            const maxTransfromX = -scrollWidth + totalWidth
            const curIdx = this.transformIdx
            let transformIdx = this.transformIdx
            let transformX = this.transformX
            let curWidth = 0
            this.isMin = false
            this.isMax = false
            const isLeft = type === 'left'
            isLeft ? transformIdx-- : transformIdx++
            const curItem = list[curIdx]
            if (curItem) {
            curWidth = curItem.getBoundingClientRect().width
            }
            if (isLeft && transformIdx > 0) {
            transformX += curWidth
            } else if (!isLeft && transformIdx < list.length) {
            transformX -= curWidth
            }
            console.log(transformX,curWidth,transformIdx,maxTransfromX,scrollWidth,'transformXtransformX');
            console.dir('navbar', navbar)
            if (transformIdx <= 0) {
            // 最小
            transformX = 0
            transformIdx = 0
            this.isMin = true
            }
            if (transformX < maxTransfromX) {
            // 最大
            this.transformX = maxTransfromX
            this.isMax = true
            return
            }
            this.transformIdx = transformIdx
            this.transformX = transformX
        },
        async changeScrollItem () {
            await this.$nextTick()
            setTimeout(() => {
                if (this.$refs['navbar-mask'] && this.$refs.navbar) {
                    this.navbarIsScroll = this.$refs['navbar-mask'].offsetWidth < this.$refs.navbar.offsetWidth
                }
            }, 300)
        },
        goAccount() {
          const route = this.$router.resolve({ path: '/personalCenter' })  
          window.open(route.href, '_blank')
        },
        getMessage() {
            let userMsg = localStorage.getItem("userMsg");
            if (userMsg) {
                this.userMsg = JSON.parse(userMsg);
                this.schoolId = this.userMsg.schoolMsg.schoolId;
                this.schoolList = this.userMsg.listschool;
            }
            //- 获取用户缓存消息
            let user = localStorage.getItem("user");
            if (user) {
                user = JSON.parse(user);
                this.sysUserMsg = user || "";
            }
        },
        clearSysUserMsg() {
            this.sysUserMsg = ''
            const list = localStorage.getItem('userList')
            localStorage.clear()
            sessionStorage.clear()
            if (list) localStorage.setItem('userList', list)
        },
        handleDialog(url, info, title) {
            this.dialogInfo.dialogUrl = url
            this.dialogInfo.dialogHeight = (info.height || info.explainTextHeight) + 'px'
            this.dialogInfo.dialogWidth = (info.width || info.explainTextWidth) + 'px'
            this.dialogInfo.diaSize = info.diaSize
            this.dialogInfo.customSize = info.customSize
            this.dialogInfo.dialogName = title
            this.dialogInfo.isVisible = true
        },
        async toLySpace() {
            // 单独为龙岩写的方法
            await this.$nextTick()
            const item = this.checkObj.list.find(item => item.region === 'toSpace')
            if (item) {
                this.active(undefined, item)
            }
        },
        //- 搜索跳转
        searchMoreFun() {
            this.$router.push({
                path: "/searchAppAndTypePage",
                query: { wd: this.searchInput, type: 1 },
            });
        },
        // 切换角色弹层
        showRoleDialog() {
            this.$emit('change-role');
        },
        // 退出登录退出登录
        logout() {
            this.$emit('on-logout');
        },
        toLogin() {
            this.$emit('to-login')
        },
        //- 切换学校
        changeSchool() {
            this.$emit('change-school');
        },
        async handleRadioChange(value) {
            localStorage.setItem('customDeskId', value)
            const param = { customDeskId: value }
            if ('isNews' in this.$route.query) {
                this.$router.push({
                    path: this.$route.path
                })
            }
            if (this.spaceid) {
                param.spaceid = this.spaceid
                await addspacedefaultdesk(param)
            } else if (this.upaceid) {
                param.upaceid = this.upaceid
                await addspacedefaultdesk(param)
            } else {
                await adddefaultdesk(param)
            }
            this.isPopValue = false
        },
        handleNavInside(query, path, openFun, dialogInfo, name) {
            const spaceid = this.$route.query.spaceid
            const upaceid = this.$route.query.upaceid
            if (spaceid) {
                query.spaceid = spaceid
                query.space = true
            } else if (upaceid) {
                query.upaceid = upaceid
                query.upace = true
            }
            if (path === '/index') {
                delete query.spaceid
                delete query.space
                delete query.upaceid
                delete query.upace
            }
            if (this.curType === 'platformInside' && query.spaceid) {
                delete query.spaceid
                delete query.space
            }
            else if (this.curType === 'platformInside' && query.upaceid) {
                delete query.upaceid
                delete query.upace
            }
            if (openFun === 'old') {
                this.$router.push({
                    path,
                    query
                });
            } else if (openFun === 'new') {
                query.navshow = false
                const route = this.$router.resolve({
                    path,
                    query
                })
                window.open(route.href, '_blank')
            } else {
                query.navshow = false
                this.dialogInfo.openType = openFun
                const route = this.$router.resolve({
                    path: "/clientSide/oaFrame/oaFrame",
                    query
                })
                this.handleDialog(route.href, dialogInfo, name)
            }
        },
        async openCloud(item, chooseOpen) {
            const type = item.linkValueItem.cloudInfo.type
            if (!type) return this.$message.error('请选择要跳转的网盘')
            let userMsg = localStorage.getItem("userMsg");
            if (userMsg) {
                userMsg = JSON.parse(userMsg)
                console.log(userMsg)
                const schoolId = userMsg.schoolMsg.schoolId
                const { code, data, msg } = await getschool({ schoolId: schoolId })
                if (code === 0) {
                    const { openstorage } = data
                    if (openstorage === 1) {
                        let url = this.$cloudurl
                        const user = localStorage.getItem('user')
                        if (user) {
                            const token = JSON.parse(user).accesstoken
                            const schoolname = userMsg.schoolMsg.name
                            const username = userMsg.realname
                            url += `?accesstoken=${token}&storagetype=${type}&schoolname=${schoolname}&username=${username}`
                            if (chooseOpen === 'old') {
                                let query = { url: url }
                                this.$router.push({
                                    path: "/bearing",
                                    query
                                })
                            } else if (chooseOpen === 'new') {
                                window.open(url, '_blank')
                            } else if (chooseOpen === 'dialog' || chooseOpen === 'rightdia') {
                                this.dialogInfo.openType = chooseOpen
                                this.handleDialog(url, item.linkValueItem.dialogInfo)
                            }
                        }
                    } else {
                        this.$message.warning('网盘未开启')
                    }
                } else {
                    this.$message.error(msg)
                }
            }
        },
        // 点击导航跳转
        async active (index, item, token) {
            this.curType = ''
            const that = this
            let type = item.region;
            sessionStorage.removeItem('catchActive')
            let dialogInfo = {
                chooseOpen: 'old',
                width: 1700,
                height: 800
            }
            if (item.linkValueItem && item.linkValueItem.dialogInfo) {
                dialogInfo = item.linkValueItem.dialogInfo
            }
            const openFun = dialogInfo.chooseOpen
            let pageUrl;
            const que = this.spaceid ? { spaceid: this.spaceid } : this.upaceid ? { upaceid: this.upaceid } : {}
            if (item.region === undefined) {
                type = 'custom'
            }
            if (item.id === 1) {
                // 官网不要跳转
                if (!this.isCustomDesk && !this.openWebsite) {
                    pageUrl = this.spaceid ? '/space/index' : this.upaceid ? '/upace/index' : '/index'
                    this.$router.push({
                        path: pageUrl,
                        query: que
                    });
                }
                let info = { topId: item.id }
                if (!this.isCustomDesk) {
                    info.customDeskId = this.chooseRoleId
                } else {
                    info.customDeskId = this.$route.query.customDeskId
                }
                if (Object.keys(this.customDeskInfo).length === 0) {
                    localStorage.setItem('catchActiveMenu', JSON.stringify(info))
                }
                this.$emit('nav-click', item)
                return true
            } else if (item.id === 2) {
                if (!this.isCustomDesk) {
                    pageUrl = this.spaceid ? '/space/oaExamine' : this.upaceid ? '/upace/oaExamine' : '/clientSide/oaExamine';
                    this.$router.push({
                        path: pageUrl,
                        query: que
                    });
                }
                this.$emit('nav-click', item)
                return true
            } else if (item.id === 3) {
                if (!this.isCustomDesk) {
                    pageUrl = this.spaceid ? '/space/workbench' : this.upaceid ? '/space/workbench' : '/clientSide/workbench';
                    this.$router.push({
                        path: pageUrl,
                        query: que
                    });
                }
                this.$emit('nav-click', item)
                return true
            } else {
                this.curType = type
                if (type === 'outside') {
                    //- 外链
                    if (!item.linkValueItem.outside.pc) return false;
                    const url = item.linkValueItem.outside.pc
                    if (dialogInfo.chooseOpen === 'old') {
                        //- 在原页面打开
                        that.$router.push({
                            path: "/bearing",
                            query: {
                                url: item.linkValueItem.outside.pc
                            }
                        });
                    } else if (dialogInfo.chooseOpen === 'new') {
                        //- 在新标签打开
                        window.open(item.linkValueItem.outside.pc);
                    } else {
                        // 弹窗
                        this.dialogInfo.openType = dialogInfo.chooseOpen
                        this.handleDialog(url, dialogInfo, '')
                    }
                    // window.open(item.function[3].pcUrl);
                } else if (type === 'inside' || type === 'platformInside') {
                    //- 站内应用
                    if (!item.linkValueItem.insideObj.id) return false;
                    const query = { categoryId: item.linkValueItem.insideObj.id, name: item.linkValueItem.insideObj.params }
                    const path = '/clientSide/oaFrame/oaFrame'
                    const diaName = item.linkValueItem.insideObj.name
                    this.handleNavInside(query, path, openFun, dialogInfo, diaName)
                } else if (type === 'custom') {
                    // 官网不要跳转
                    console.log((Boolean(this.$route.query.id) && Boolean(this.$route.query.l)), (!this.isCustomDesk && !this.openWebsite),'asdddddddddddd')
                    if ((Boolean(this.$route.query.id) && Boolean(this.$route.query.l)) || (!this.isCustomDesk && !this.openWebsite)) {
                        // 加这段的意义是  由于在路由那边加上了key 所以每次点击的时候都会刷新页面 因此需要做一个缓存
                        if (this.$route.path === '/clientSide/oaExamine' || this.$route.path === '/clientSide/workbench') {
                            const id = item.id
                            const catchPath = this.$route.path
                            const isParent = item.parent_id === 0
                            const catchActive = {
                                catchPath,
                                id,
                                isParent
                            }
                            sessionStorage.setItem('catchActive', JSON.stringify(catchActive))
                        } else {
                            sessionStorage.removeItem('catchActive')
                        }
                        pageUrl = '/index'
                        const __query = {}
                        if (this.spaceid) {
                            pageUrl = '/space/index'
                            __query.spaceid = this.spaceid
                        } else if (this.upaceid) {
                            pageUrl = '/upace/index'
                            __query.upaceid = this.upaceid
                        }
                        this.$router.push({
                            path: pageUrl,
                            query: __query
                        });
                    }
                    let info = { topId: item.id }
                    if (!this.isCustomDesk) {
                        info.customDeskId = this.chooseRoleId
                    } else {
                        info.customDeskId = this.$route.query.customDeskId
                    }
                    if (Object.keys(this.customDeskInfo).length === 0) { 
                        localStorage.setItem('catchActiveMenu', JSON.stringify(info))
                    }
                    let cPage = localStorage.getItem('cPage')
                    if (cPage) {
                        cPage = JSON.parse(cPage)
                        if (cPage.isClick) {
                            localStorage.removeItem('cPage')
                        }
                    }
                    this.$emit('nav-click', item)
                    return true
                } else if (type === 'customDesk' || type === 'platformCustom') {
                    //- 自定义页面
                    if (!item.linkValueItem.customObj.pcUrl) return false;
                    const opt = { chooseOpen: openFun, customSize: dialogInfo.customSize, dialogInfo, type, customInfo: item, navType: 'nav', token }
                    this.goCustomDesk(item.linkValueItem.customObj, opt)
                } else if (type === 'toSpace') {
                    const spaceInfo = item.linkValueItem.spaceInfo
                    if (!spaceInfo && !spaceInfo.spaceId) {
                        this.$message.error('请配置空间信息')
                        return
                    }
                    const sapceList = await this.getToSpaceId(spaceInfo)
                    if (!sapceList) return
                    if (sapceList.length === 0) {
                        this.$message.info('该账号暂无空间')
                    } else if (sapceList.length === 1) {
                        const path = '/space/index'
                        const curSpace = sapceList[0]
                        const par = {
                            spaceid: curSpace.spaceId
                        }
                        this.handleNavInside(par, path, openFun, dialogInfo, '')
                    } else if (sapceList.length > 1) {
                        this.openSpaceChoose = true
                        const curConfirmSpace = { chooseOpen: openFun, dialogInfo, isApp: false }
                        this.curConfirmSpace = curConfirmSpace
                    }
                } else if (type === 'toPlatform') {
                    this.handleNavInside({}, '/index', openFun, dialogInfo, '')
                } else if (type === 'ability') {
                    const abilityInfo = item.linkValueItem.abilityInfo
                    if (!abilityInfo) {
                        this.$message.error('请选择能力管理')
                        return
                    }
                    const { width: dialogWidth, height: dialogHeight, diaSize, customSize } = dialogInfo
                    this.openAbility(abilityInfo, openFun, { dialogWidth, dialogHeight, diaSize, customSize }, 'nav')
                } else if (type === 'toLogin') {
                    this.toLogin()
                } else if (type === 'toNav') {
                    const navInfo = item.linkValueItem.navInfo
                    if (this.$route.path === '/clientSide/oaExamine' || this.$route.path === '/clientSide/workbench') {
                        const { type, page } = navInfo
                        if (type === 'top') {
                            this.active(0, page)
                        } else {
                            this.$message.error('配置错误')
                        }
                        return
                    }
                    this.$emit('changeNav', navInfo)
                } else if (type === 'toCloud') {
                    this.openCloud(item, dialogInfo.chooseOpen)
                } else if (type === 'toSystemManagement') {
                    const systemInfo = item.linkValueItem.systemInfo
                    if (!systemInfo) {
                        this.$message.error('请选择配置系统管理功能')
                        return
                    }
                    const info = {
                        info: systemInfo,
                        chooseOpen: openFun,
                        dialogInfo,
                        type: 'nav'
                    }
                    this.openSystemManagement(info)
                }
            }
        },
        mouseleave(idx) {
            this.toggleDropHeight(idx, false)
        },
        mouseNaventer(idx) {
            this.toggleDropHeight(idx, true, true)
        },
        mouseenter(idx) {
            this.toggleDropHeight(idx, true)
        },
        transitionend(e) {
            const target = e.target
            if (e.target.style.height === '0px') {
                target.style.width = 'initial'
            } else {
                target.style.width = 'fit-content'
            }
        },
        toggleDropHeight(idx, type, isNav = false) {
            /**
             * @param idx ref索引
             * @param type 是进入还是离开
             * @param isNav 是否需要把高度变成0
             */
            if (this.styleInfo.childDirection !== 'drop') return
            if (!this.$refs[`drop-${idx}`]) return
            const cur = this.$refs[`drop-${idx}`][0]
            if (cur) {
                if (type) {
                    let curH = cur.getAttribute('customH')
                    let _h = null
                    if (curH !== null) {
                        cur.style.height = curH + 'px'
                        return
                    }
                    cur.style.height = 'auto'
                    curH = cur.getBoundingClientRect().height
                    cur.setAttribute('customH', curH)
                    if (!isNav) {
                        cur.style.height = 0
                    }
                    // eslint-disable-next-line no-unused-vars
                    _h = cur.offsetHeight
                    cur.style.height = curH + 'px'
                } else {
                    cur.style.height = 0
                }
            }
        },
        isAppenDrop(item) {
            return item.lists.length !== 0 && this.styleInfo.childDirection === 'drop'
        },
        async getUserVip() {
            try {
              const res = await axiosBase({}, '/openapi/getusermember ')
              if (res.code === 0) {
                this.openVip = res.data.openmember ? true : false
                console.log("this.openVip===",this.openVip);
                if(res.data.member.length > 0){
                  const memberNames = res.data.member.map(item => item.name).join('/')
                  this.isVip = true
                  this.memberInfo = {
                    level: memberNames,
                    expireDate: calculateDaysDiff(res.data.member[0].validate) + '天',
                  }
                }
              } else {
                this.$message.error(res.msg)
              }
            } catch (error) {
              console.error('获取会员信息失败:', error)
            //   this.$message.error('获取会员信息失败')
            }
          },
        // 开通会员
        goVip(){
            this.vipPayShow = true
        },
        // VIP个人中心
        goVipCenter(){
            const route = this.$router.resolve({ path: '/vipCenter' })  
            window.open(route.href, '_blank')
        }
    }
}